import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCommandHistory } from 'Screens/Dashboard/actions/Actions';
import Card from 'Screens/Dashboard/components/ToolbarItems/Card';
import { selectCommandHistory, selectIsLoadingState } from 'store/Dashboard/selectors';
import { ButtonLink } from 'Common/Components/ButtonLink/styled';
import { Wrapper, Empty } from './styled';
import { round } from 'lodash';
import { selectCurrentWorkspace } from 'store/Faraday/selectors';
import SpinnerComponent from 'Common/Components/SpinnerContainer';

const CommandHistory = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const history = useSelector(selectCommandHistory);
  const isFetching = useSelector(state => selectIsLoadingState(state, 'commandHistory'));
  const currentWorkspace = useSelector(selectCurrentWorkspace);

  const viewMore = () => {
    setPage(page + 1);
  };

  useEffect(() => {
    dispatch(getCommandHistory(page));
  }, [dispatch, page, currentWorkspace]);

  if (isFetching) return <SpinnerComponent height={ '250px' } />;

  return (
    <Wrapper>
      { history.slice(0, history.length).map((h) => {
        return (
          <Card
            key={ `${h._id}` }
            target={ `${h.command} ${h.params}` }
            user={ h.creator }
            duration={ round(h.duration, 2) }
            date={ h.metadata.create_time }
          />
        );
      })}

      { (isFetching && history.length === 0) && <Card isSkeleton /> }
      { history.length === 0 && <Empty>No history has been found yet.</Empty>}
      { history.length > (page * 15) && <ButtonLink isLoading={ isFetching } onClick={ viewMore }>Show more</ButtonLink> }
    </Wrapper>
  );
};

export default CommandHistory;
